import React, { useMemo } from 'react';

import { TQuestionnaireProlongations, TQuestionnaireRepayment } from '@/types/questionnaires';

import { useTranslate } from '@/shared/hooks/use-translate';
import { priceFormat } from '@/shared/utils/currency';

import { DetailsPaymentExtendItem } from './extend-item';
import { DetailsPaymentItem } from './item';
import {
    StyledDetailsExtendRentTitle,
    StyledDetailsPayment,
    StyledDetailsPaymentBillTitle,
    StyledDetailsPaymentPaid,
} from './styled';

type TDetailsPaymentProps = {
    repayments: TQuestionnaireRepayment[];
    prolongations: TQuestionnaireProlongations[];
};

export const DetailsPayment: React.FC<TDetailsPaymentProps> = ({ repayments, prolongations = [] }) => {
    const { t } = useTranslate();

    const allSum = useMemo(() => repayments.reduce((prev, check) => prev + check.amount, 0), []);

    return (
        <StyledDetailsPayment>
            <StyledDetailsPaymentBillTitle>{t('Платежи')}</StyledDetailsPaymentBillTitle>

            {repayments?.map((bill) => <DetailsPaymentItem bill={bill} key={bill.created_at.toString()} />)}

            <hr />

            <StyledDetailsPaymentPaid>
                <span>{t('Итого')}: </span> <span> {priceFormat(allSum, 0)} ₸ </span>
            </StyledDetailsPaymentPaid>

            {prolongations?.length > 0 && (
                <>
                    <StyledDetailsExtendRentTitle>{t('Продление срока аренды')}</StyledDetailsExtendRentTitle>

                    {prolongations?.map((prolongation) => (
                        <DetailsPaymentExtendItem
                            prolongation={prolongation}
                            key={prolongation.created_at.toString()}
                        />
                    ))}
                </>
            )}
        </StyledDetailsPayment>
    );
};
